import { ReactNode, useCallback, useRef, useState } from 'react';
import { Announce, AnnounceContext } from './hooks';

// WCAG 4.1.3: one polite live region for status messages (results loaded,
// check-in opened, class added). Two alternating nodes so repeating the same
// message is still announced.
export function AnnouncerProvider({ children }: { children: ReactNode }) {
  const [slots, setSlots] = useState<[string, string]>(['', '']);
  const flip = useRef(0);
  const announce = useCallback<Announce>((message) => {
    flip.current = 1 - flip.current;
    const i = flip.current;
    setSlots(i === 0 ? [message, ''] : ['', message]);
  }, []);
  return (
    <AnnounceContext.Provider value={announce}>
      {children}
      <div className="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
        {slots[0]}
      </div>
      <div className="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
        {slots[1]}
      </div>
    </AnnounceContext.Provider>
  );
}
